import SOSByKeyRetailer from "./SOSByKeyRetailer";
export default SOSByKeyRetailer;
